<template>
    <div>
        <x-header :left-options="{backText: ''}" >{{$t('account.credit.title')}}</x-header>
        <group>
        <x-input :title="$t('account.password.oldPassword')" :placeholder="$t('account.password.enterOldPassword')" text-align="right" type="password" required v-model="oldPassword"></x-input>
        <x-input :title="$t('account.password.newPassword')" :placeholder="$t('account.password.enterNewPassword')" text-align="right" type="password" required v-model="newPassword"></x-input>
        <x-input :title="$t('account.password.confirmPassword')" :placeholder="$t('account.password.enterNewPassword')" text-align="right" type="password" required v-model="newPasswordConfirm"></x-input>
        </group>
        <div style="padding: 20px 25px 0px 25px; color: red">{{$t('account.password.remind')}}</div>
        <div style="padding: 20px 30px 0px 30px">
            <x-button 
            v-if="newPassword !== newPasswordConfirm || newPassword == '' || newPasswordConfirm == '' || newPassword.toString().length < 6" 
            type="primary" style="background-color: #5890DC;" @click.native="triggerAlert" >{{$t('account.password.editPassword')}}</x-button>
            <x-button v-else-if="newPassword == newPasswordConfirm " variant="success" type="primary" 
            style="background-color: #5890DC;" @click.native="editPassword">{{$t('account.password.editPassword')}}</x-button>
        </div>
        <div v-transfer-dom>
            <alert v-model="alert" :title="$t('account.credit.remind')" :button-text="$t('general.confirm')" >{{$t('account.password.failAlert')}}</alert>
            <alert v-model="success" :title="$t('account.credit.remind')" :button-text="$t('general.confirm')" @click.native="$router.push('/account')">{{$t('account.password.successAlert')}}</alert>
        </div>
    </div>
    
</template>

<script>
import { XHeader, XInput, XButton, Alert, TransferDomDirective as TransferDom } from 'vux' 
export default {
    name: 'EditPassword',
    directives: {
        TransferDom
    },
    components: {
        XHeader, 
        XInput,
        XButton,
        Alert,
        TransferDom
    },
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
            alert: false,
            success: false
            
        }
    },
    methods: {
        editPassword(){
            this.$store.dispatch('Account/editUserPassword', {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                newPasswordConfirm: this.newPasswordConfirm
        })
        .then((json) => {
      
        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login?type=1');
        }else if(json.status == 200){
          this.success = true
        }
        }).catch((err) => {
            console.error(err);
        });
    },
        triggerAlert() {
            this.alert = true
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/Account/containers/Password.vue